/**
 * Labstep
 *
 * @module components/ProtocolCondition/Action/Reporting/ProtocolValue
 * @desc Open modal to compare data
 */

import { ProtocolConditionExplorerContainer as ProtocolConditionExplorer } from 'labstep-web/components/ProtocolCondition/Explorer';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { ProtocolConditionActionCompareDataProtocolValueProps } from './types';

export const ProtocolConditionActionCompareDataProtocolValue: React.FC<
  ProtocolConditionActionCompareDataProtocolValueProps
> = ({ group, protocolValue, actionComponentType }) => {
  return (
    <ModalDefault
      header="Data Explorer"
      size="fullscreen"
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          onClick={toggleModal}
          text="Compare Data"
          type={actionComponentType}
          icon={ICONS.protocol_condition.secondary}
          showIcon
          elementProps={{
            border: 'fancy',
          }}
        />
      )}
      content={() => (
        <ProtocolConditionExplorer
          group={group}
          protocolValue={protocolValue}
        />
      )}
    />
  );
};
